<template>
  <base-sheet :visible="visible" @close="$emit('close')">
    <p v-if="learningObject && learningObject.name" class="vxl-sheet__label">
      {{ learningObject.name }}
    </p>

    <p v-if="!hasAccess" class="vxl-sheet__alert">
      <i class="material-icons">block</i>
      Acesso suspenso — você só pode remover o download.
    </p>

    <button v-if="hasAccess" class="vxl-sheet__row" @click="onAction('play')">
      <span class="vxl-sheet__row-icon" :style="{ color: $theme.primaryColor }">▶</span>
      <span>Reproduzir</span>
    </button>

    <button class="vxl-sheet__row vxl-sheet__row--danger" @click="onAction('remove')">
      <i class="material-icons vxl-sheet__row-icon">delete_outline</i>
      <span>Remover download</span>
    </button>

    <button class="vxl-sheet__action vxl-sheet__action--ghost" @click="$emit('close')">
      Cancelar
    </button>
  </base-sheet>
</template>

<script>
import BaseSheet from '@/components/base/BaseSheet';

export default {
  name: 'LearningObjectActionsSheet',
  components: { BaseSheet },
  props: {
    visible: { type: Boolean, default: false },
    learningObject: { type: Object, default: null },
    // false = enroll dono foi revogado (backend não retorna mais). Esconde
    // "Reproduzir" pra não deixar user tocar conteúdo de curso sem acesso.
    // Remoção continua disponível pra liberar espaço.
    hasAccess: { type: Boolean, default: true }
  },
  methods: {
    onAction (name) {
      if (!this.learningObject) return;
      this.$emit(name, { enrollId: this.learningObject.enrollId, loId: this.learningObject.loId });
      this.$emit('close');
    }
  }
};
</script>
